import services from '../../services'

const state = {
    isOpenRegist: false, // 是否开启报名注册
    funcEnable: { // 各个功能点是否启用
        navigation: { // 导航
            home: true, // 首页
            person: true, // 人员
            hotel: { // 酒店模块
                companyHotel: true, // 公司酒店
                travelHotel: true, // 商旅酒店
                personalHotel: true // 个人酒店
            },
            vehicle: { // 车辆模块
                companyVehicle: true, // 公司车辆
                travelVehicle: true // 商旅车辆
            },
            airTicket: true, // 机票
            trainTicket: true // 火车票
        },
        myOrder: { // 我的订单
            recentOrder: true, // 近期订单
            hotel: { // 酒店订单
                companyHotel: true, // 公司酒店
                travelHotel: true, // 商旅酒店
                personalHotel: true // 个人酒店
            },
            vehicle: { // 车辆订单
                companyVehicle: true, // 公司用车
                travelVehicle: true // 商旅用车
            }
        },
        orderManage: { // 订单管理
            travelBooking: { // 商旅预订
                hotelOrder: true, // 酒店订单
                vehicleOrder: true // 用车订单
            },
            personalHotel: true // 个人酒店订单
        },
        personManage: true, // 人员管理
        myToDo: true, // 我的待办
        switchConfig: { // 开关配置
            resourceSwitch: true, // 资源开关
            privacyConfig: true, // 隐私配置
            processSwitch: true // 流程开关
        },
        resourceConfig: { // 资源配置
            hotel: { // 酒店资源
                companyHotel: true, // 公司酒店
                travelHotel: true, // 商旅酒店
                personalHotel: true // 个人酒店
            },
            travelVehicle: true, // 商旅用车
            airTicket: true, // 机票
            trainTicket: true // 火车票
        },
        financialManagement: { // 财务管理
            budgetManage: true, // 预算管理
            financialStatement: { // 财务报表
                inventory: true, // 库存管理表
                checkIn: true, // 酒店实际入住曲线表
                sale: true // 酒店销售贡献比例图
            }
        }
    }
}

const mutations = {
    setFuncEnable(state, payload) {
        state.funcEnable = payload
    },
    clearFuncEnable(state, payload) {
        state.funcEnable = initFuncEnable(state.funcEnable, true)
    },
    setIsOpenRegist(state, payload) {
        state.isOpenRegist = payload
    }
}

const actions = {

    /**
     *  查询资源开关配置
     * @param {*} context
     * @param {*} param
     */
    getResourceSwitchAct(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.switchConfigSer.getResourceSwitchSer(param).then((res) => {
                // 报名注册，有一个没开，则总开关关闭
                const result = res.data.data || {}
                const isOpenRegist = Object.keys(result).some(key => {
                    return (key.indexOf('Registration') > -1 && result[key] === 'Y')
                })
                context.commit('setIsOpenRegist', isOpenRegist)
                resolve(res)
            })
        })
    },

    /**
     *  编辑资源开关配置
     * @param {*} context
     * @param {*} param
     */
    updateResourceSwitchAct(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.switchConfigSer.updateResourceSwitchSer(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     *  查询资源开关配置修改日志
     * @param {*} context
     * @param {*} param
     */
    getResourceSwitchLogAct(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.vehicleSer.getVehLogSer(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     *  查询资源配置是否存在订单
     * @param {*} context
     * @param {*} param
     */
    getOrderExistsAct(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.switchConfigSer.getOrderExistsSer(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     *  查询流程开关配置
     * @param {*} context
     * @param {*} param
     */
    getProcessSwitchAct(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.switchConfigSer.getProcessSwitchSer(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     *  查询审批流程列表
     * @param {*} context
     * @param {*} param
     */
    getProcessListAct(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.switchConfigSer.getProcessListSer(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     *  保存流程
     * @param {*} context
     * @param {*} param
     */
    saveProcessAct(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.switchConfigSer.saveProcessSer(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     *  修改流程开关
     * @param {*} context
     * @param {*} param
     */
    updateProcessSwitchAct(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.switchConfigSer.updateProcessSwitchSer(param).then((res) => {
                resolve(res)
            })
        })
    },

    /**
     *  查询流程开关修改日志
     * @param {*} context
     * @param {*} param
     */
    getProcessSwitchHistoryAct(context, param = {}) {
        return new Promise((resolve, reject) => {
            services.switchConfigSer.getProcessSwitchHistorySer(param).then((res) => {
                resolve(res)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

// 初始化对象
const initFuncEnable = (data, value) => {
    Object.keys(data).forEach(item => {
        if (typeof data[item] === 'object') {
            initFuncEnable(data[item], value)
        } else {
            data[item] = value
        }
    })
    return data
}
